// services/signOutUnconfirmed.ts

/**
 * A sign-in refused because a Log Out still owed on this browser could not
 * be confirmed (ORA-1089): starting it would leave the previous person's
 * live session cookie unguarded.
 */
export const SIGN_OUT_UNCONFIRMED_CODE = 'SIGN_OUT_UNCONFIRMED';

export const SIGN_OUT_UNCONFIRMED_MESSAGE =
  "Couldn't reach Ora. Check your connection and try again.";
